import {
  TDevice,
  TDeviceCasingTamperStatus,
} from "src/data/devices/types/deviceTypes"

export function isDeviceTampered(device: TDevice): boolean {
  return getTamperStatus(device.casing_tamper) === "detected"
}

export function getTamperStatus(
  casingTamper: TDevice["casing_tamper"]
): TDeviceCasingTamperStatus | undefined {
  if (!casingTamper) {
    return undefined
  }

  return casingTamper.status
}
